import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../..'

const getPartnerListDrawerIsOpen = (state: RootState) => state.ui.partnerList.isOpen
const getFilterDrawerIsOpen = (state: RootState) => state.ui.filterDrawer.isOpen
const getSelectedPartnerDrawerIsOpen = (state: RootState) => state.ui.individualProfileDrawer.isOpen

export const partnerListIsOpenSelector = createSelector(
    getPartnerListDrawerIsOpen,
    isOpen => isOpen
)

export const filterDrawerIsOpenSelector = createSelector(
    getFilterDrawerIsOpen,
    isOpen => isOpen
)

export const partnerProfileDrawerIsOpenSelector = createSelector(
    getSelectedPartnerDrawerIsOpen,
    isOpen => isOpen
)
